module.exports = __webpack_public_path__ + "img/unknown.d343f4bf.png";